export default "__VITE_ASSET__9cUcg9lo__"